(() => {
  const makeHeaderScrollSafe = () => {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const sectionWrapper = header.closest('.shopify-section');
    if (sectionWrapper) {
      sectionWrapper.style.position = 'sticky';
      sectionWrapper.style.top = '0';
      sectionWrapper.style.zIndex = '60';
      sectionWrapper.style.overflow = 'visible';
    }

    header.style.position = 'sticky';
    header.style.top = '0';
    header.style.zIndex = '60';
  };

  const addMenuScrollStyles = () => {
    if (document.getElementById('majbwr-scroll-menu-fix')) return;

    const style = document.createElement('style');
    style.id = 'majbwr-scroll-menu-fix';
    style.textContent = `
      .site-header,
      .header {
        overflow: visible !important;
      }
      .gear-menu__panel,
      .edition-menu__panel,
      .predictive-search__panel {
        max-height: calc(100vh - 92px);
        overflow-y: auto;
        overscroll-behavior: contain;
        scrollbar-gutter: stable;
      }
      .product__primary-image,
      .product-editorial img {
        cursor: zoom-in;
      }
      .product-zoom__nav,
      .product-zoom__counter {
        display: none;
      }
      [data-product-zoom-dialog][open] .product-zoom__nav,
      [data-product-zoom-dialog][open] .product-zoom__counter {
        display: flex;
      }
      .product-zoom__nav {
        position: fixed;
        top: 50%;
        z-index: 10002;
        width: 46px;
        height: 46px;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(255,255,255,.55);
        border-radius: 999px;
        background: rgba(0,0,0,.55);
        color: #fff;
        font-size: 30px;
        line-height: 1;
        cursor: pointer;
        transform: translateY(-50%);
        -webkit-tap-highlight-color: transparent;
      }
      .product-zoom__nav--prev { left: 18px; }
      .product-zoom__nav--next { right: 18px; }
      .product-zoom__counter {
        position: fixed;
        left: 50%;
        bottom: 18px;
        z-index: 10002;
        min-width: 58px;
        min-height: 32px;
        align-items: center;
        justify-content: center;
        padding: 4px 10px;
        border-radius: 999px;
        background: rgba(0,0,0,.55);
        color: #fff;
        font-size: 13px;
        letter-spacing: .06em;
        transform: translateX(-50%);
        pointer-events: none;
      }
      [data-product-zoom-dialog][open] .product-zoom__image {
        touch-action: pan-y pinch-zoom;
        user-select: none;
        -webkit-user-drag: none;
      }
      @media (max-width: 749px) {
        .product-zoom__nav {
          width: 42px;
          height: 42px;
          font-size: 27px;
        }
        .product-zoom__nav--prev { left: 10px; }
        .product-zoom__nav--next { right: 10px; }
      }
    `;
    document.head.appendChild(style);
  };

  const wireProductGallery = () => {
    const productMedia = document.querySelector('.product__media');
    if (!productMedia || productMedia.dataset.majbwrGalleryWired === 'true') return;

    const primary = productMedia.querySelector('.product__primary-image');
    const dialog = productMedia.querySelector('[data-product-zoom-dialog]');
    const zoomImage = dialog?.querySelector('.product-zoom__image');
    if (!primary || !dialog || !zoomImage) return;

    productMedia.dataset.majbwrGalleryWired = 'true';

    const thumbnails = [...productMedia.querySelectorAll('[data-gallery-thumb]')];
    const editorialImages = [...document.querySelectorAll('.product-editorial img')];

    const items = thumbnails.length
      ? thumbnails
          .map((thumbnail) => ({
            src: thumbnail.dataset.gallerySrc || '',
            alt: thumbnail.dataset.galleryAlt || ''
          }))
          .filter((item) => item.src)
      : [{ src: primary.currentSrc || primary.src, alt: primary.alt || '' }];

    if (!items.length) return;

    const normalizeUrl = (url) => {
      if (!url) return '';

      try {
        const parsed = new URL(url, window.location.href);
        ['width', 'height', 'crop'].forEach((key) => parsed.searchParams.delete(key));
        return parsed.href;
      } catch {
        return url;
      }
    };

    const selectedThumbIndex = thumbnails.findIndex((thumbnail) => {
      return thumbnail.classList.contains('is-active') || thumbnail.getAttribute('aria-pressed') === 'true';
    });

    let activeIndex = selectedThumbIndex >= 0 ? selectedThumbIndex : 0;
    let touchStartX = null;
    let touchStartY = null;

    const prevButton = document.createElement('button');
    prevButton.type = 'button';
    prevButton.className = 'product-zoom__nav product-zoom__nav--prev';
    prevButton.setAttribute('aria-label', 'Previous product image');
    prevButton.innerHTML = '&#8249;';

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'product-zoom__nav product-zoom__nav--next';
    nextButton.setAttribute('aria-label', 'Next product image');
    nextButton.innerHTML = '&#8250;';

    const counter = document.createElement('div');
    counter.className = 'product-zoom__counter';
    counter.setAttribute('aria-hidden', 'true');

    dialog.append(prevButton, nextButton, counter);

    const preloadAround = () => {
      if (items.length < 2) return;

      const nextIndex = (activeIndex + 1) % items.length;
      const previousIndex = (activeIndex - 1 + items.length) % items.length;
      [nextIndex, previousIndex].forEach((index) => {
        const preload = new Image();
        preload.src = items[index].src;
      });
    };

    const syncPrimaryState = (index) => {
      const item = items[index];
      if (!item) return;

      primary.dataset.zoomIndex = String(index);
      primary.dataset.zoomSrc = item.src;
      primary.dataset.zoomAlt = item.alt;
    };

    const render = () => {
      const item = items[activeIndex];
      if (!item) return;

      zoomImage.removeAttribute('srcset');
      zoomImage.removeAttribute('sizes');
      zoomImage.src = item.src;
      zoomImage.alt = item.alt || primary.alt || '';

      counter.textContent = `${activeIndex + 1} / ${items.length}`;

      const multiple = items.length > 1;
      prevButton.hidden = !multiple;
      nextButton.hidden = !multiple;
      counter.hidden = !multiple;

      preloadAround();
    };

    const goTo = (index) => {
      activeIndex = (index + items.length) % items.length;
      render();
    };

    const openZoomAt = (index) => {
      goTo(index);
      if (!dialog.open) dialog.showModal();
    };

    const currentPrimaryIndex = () => {
      const storedIndex = Number.parseInt(primary.dataset.zoomIndex || '', 10);
      return Number.isInteger(storedIndex) && storedIndex >= 0 && storedIndex < items.length
        ? storedIndex
        : activeIndex;
    };

    syncPrimaryState(activeIndex);

    primary.addEventListener('click', () => {
      openZoomAt(currentPrimaryIndex());
    });

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        if (!items[index]) return;
        activeIndex = index;
        syncPrimaryState(index);
      });
    });

    productMedia.querySelectorAll('[data-product-zoom]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        openZoomAt(currentPrimaryIndex());
      }, true);
    });

    editorialImages.forEach((image) => {
      image.addEventListener('click', () => {
        const imageKey = normalizeUrl(image.currentSrc || image.src);
        const index = items.findIndex((item) => normalizeUrl(item.src) === imageKey);
        openZoomAt(index >= 0 ? index : 0);
      });
    });

    prevButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goTo(activeIndex - 1);
    });

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goTo(activeIndex + 1);
    });

    dialog.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    dialog.addEventListener('touchend', (event) => {
      if (touchStartX === null || touchStartY === null) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;

      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      goTo(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (!dialog.open) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(activeIndex + 1);
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    render();
  };

  const closeMenusAfterNavigation = () => {
    document.querySelectorAll('.gear-menu a, .mobile-nav a').forEach((link) => {
      link.addEventListener('click', () => {
        link.closest('details[open]')?.removeAttribute('open');
      });
    });
  };

  makeHeaderScrollSafe();
  addMenuScrollStyles();
  wireProductGallery();
  closeMenusAfterNavigation();
})();
